import { RootState } from '../types';

export const getMainClientSelector = (state: RootState) => state.client
